import AdminTable from 'layouts/AdminTable';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import FormTextInput from 'components/FormTextInput/FormTextInput';
import FormTextInputTranslatable from 'components/FormTextInput/FormTextInputTranslatable';
import FormControlStickyButton from 'components/FormControlStickyButton/FormControlStickyButton';
import SelectInput from 'components/FormSelect/SelectInput';
import { useTranslation } from 'react-i18next';

import { getDishesSortOrderOptions } from '../dishesSortOrder';

const FormView = ({
  state,
  isEdit,
  handleInputChange,
  handleDishesSortOrderChange,
  handleSubmit,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <AdminTable
        title={
          isEdit
            ? t('dishCategories.form.editTitle')
            : t('dishCategories.form.addTitle')
        }
      >
        <GridContainer>
          <GridItem sm={6}>
            <FormTextInputTranslatable
              label={`${t('form.field.name')}*`}
              name="name"
              value={state.name}
              handleChange={handleInputChange}
              errors={state.errors}
              inputSize={12}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem sm={6}>
            <FormTextInput
              label={`${t('form.field.order')}*`}
              name="position"
              value={state.position}
              type="number"
              handleChange={handleInputChange}
              errors={state.errors}
              inputSize={12}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem sm={6}>
            <SelectInput
              label={t('dishCategories.form.dishesSortOrder')}
              name="dishesSortOrder"
              id="dishesSortOrder"
              options={getDishesSortOrderOptions(t)}
              value={state.dishesSortOrder}
              mapBy="value"
              trackBy="key"
              handleChange={handleDishesSortOrderChange}
            />
          </GridItem>
        </GridContainer>
      </AdminTable>
      <FormControlStickyButton
        discardText={t('form.cancel')}
        submitText={t('form.save')}
        cancelPath="/admin/dish-categories"
        handleSubmit={handleSubmit}
      />
    </>
  );
};

export default FormView;
